<template>
  <!-- eslint-disable max-len -->
  <div>
    <div class="pc-header">
      <div class="content">
        <div class="navigation">
          <div class="logo" @click="goDefaultPage">
            <img src="@/assets/imgs/layout/logo-header.png" alt="">
          </div>
          <router-link class="item" :class="{'active': currentPath === '/affiliate/dashboard'}" to="/affiliate/dashboard">{{ $t('common.nav.affiliate.dashboard') }}</router-link>
          <router-link class="item" :class="{'active': currentPath === '/affiliate/report'}" to="/affiliate/report">{{ $t('common.nav.affiliate.report') }}</router-link>
          <router-link class="item" :class="{'active': currentPath === '/affiliate/member-reward'}" to="/affiliate/member-reward">{{ $t('memberReward.memberRewards') }}</router-link>
          <div class="item">
            <el-dropdown trigger="click" @command="handleToolsCommand">
              <span class="el-dropdown-link">
                <span :class="{'active': ['/affiliate/tools', '/affiliate/exclusive-link', '/affiliate/recent-activities', '/affiliate/product-media'].includes(currentPath)}">
                  {{ $t('common.nav.affiliate.affiliateTool') }}
                </span><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="header-nav-dropdown">
                <el-dropdown-item command="1" :class="{'active': currentPath === '/affiliate/tools'}">{{ $t('common.nav.affiliate.affiliateTool1') }}</el-dropdown-item>
                <el-dropdown-item command="2" :class="{'active': currentPath === '/affiliate/exclusive-link'}">{{ $t('common.nav.affiliate.affiliateTool2') }}</el-dropdown-item>
                <el-dropdown-item command="3" :class="{'active': currentPath === '/affiliate/recent-activities'}">{{ $t('common.nav.affiliate.affiliateTool3') }}</el-dropdown-item>
                <el-dropdown-item command="4" :class="{'active': currentPath === '/affiliate/product-media'}">
                  <div class="dropdown-item-product-media">
                      {{ $t('common.nav.affiliate.affiliateTool4') }}
                      <img v-show="isShowNewBadge" src="../../assets/icons/new-badge.svg"/>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div @click="mixpanel('NAV_Help_Clicked')">
            <router-link class="item" :class="{'active': currentPath === '/affiliate/help'}" to="/affiliate/help">{{ $t('common.nav.affiliate.help') }}</router-link>
          </div>
        </div>
        <div class="system-info">
          <div class="info">
            <el-popover
              placement="bottom-end"
              trigger="click"
              popper-class="header-notification-popover"
              :value="notifyVisible"
              @show="$refs.unreadNotificationRef.getNotificationList()">
              <div slot="reference">
                <KkIconWithBadge
                  icon-name="ic_bell_line"
                  size="md"
                  :isShowBadge="unreadBadge ? true : false"
                  :badge-value="unreadBadge"
                />
              </div>
              <unread-notification ref="unreadNotificationRef" @unread="onSetUnreadBadge" @close="notifyVisible=false"></unread-notification>
            </el-popover>
          </div>
          <div class="item">
            <el-dropdown
              trigger="click"
              @command="changeNavLanguage($event, 'affiliate')">
              <span class="el-dropdown-link">
                {{ currentLanguage }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="header-nav-dropdown">
                <el-dropdown-item
                  v-for="item of navLangList"
                  :key="item.value"
                  :command="item.value"
                  :class="{'active': currentLanguage === item.label}">
                  {{ item.label }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ affiliateInfo.contact_last_name || '' }}
                {{ affiliateInfo.contact_first_name || '' }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="header-nav-dropdown">
                <el-dropdown-item command="1" v-if="isKKpartners">{{ $t('common.nav.affiliate.switchToMerchantPortal') }}</el-dropdown-item>
                <el-dropdown-item command="2">{{ $t('common.nav.affiliate.accountInfo') }}</el-dropdown-item>
                <el-dropdown-item command="3">{{ $t('common.nav.logout') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="mweb-header">
      <div class="menu-btn" @click="handleMenu">
        <KkIcon name="ic_bars_line_semibold" />
      </div>
      <div class="logo" @click="goDefaultPage">
        <img src="@/assets/imgs/layout/logo-header.png" alt="">
      </div>
      <el-drawer
        direction="ttb"
        size="100%"
        :with-header="false"
        :modal="false"
        :visible.sync="showMenu"
        :show-close="false"
      >
        <div class="menu-list">
          <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/dashboard'}" @click="goPage('/affiliate/dashboard')">{{ $t('common.nav.affiliate.dashboard') }}</div>
          <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/report'}" @click="goPage('/affiliate/report')">{{ $t('common.nav.affiliate.report') }}</div>
          <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/member-reward'}" @click="goPage('/affiliate/member-reward')">{{ $t('memberReward.memberRewards') }}</div>
          <el-collapse>
            <el-collapse-item :title="$t('common.nav.affiliate.affiliateTool')">
              <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/tools'}" @click="goPage('/affiliate/tools')">{{ $t('common.nav.affiliate.affiliateTool1') }}</div>
              <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/exclusive-link'}" @click="goPage('/affiliate/exclusive-link')">{{ $t('common.nav.affiliate.affiliateTool2') }}</div>
              <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/recent-activities'}" @click="goPage('/affiliate/recent-activities')">{{ $t('common.nav.affiliate.affiliateTool3') }}</div>
              <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/product-media'}" @click="goPage('/affiliate/product-media')">
              <div class="dropdown-item-product-media">
                {{ $t('common.nav.affiliate.affiliateTool4') }}
                <img v-show="isShowNewBadge" src="../../assets/icons/new-badge.svg"/></div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/help'}" @click="goPage('/affiliate/help')">{{ $t('common.nav.affiliate.help') }}</div>
          <div class="item k-body-md" :class="{'active': currentPath === '/affiliate/notification'}" @click="goPage('/affiliate/notification')">
            <span>{{ $t('notification.popup.title') }}</span>
            <span class="notice-num k-subtitle-md">{{ unreadBadge }}</span>
          </div>
          <el-collapse>
            <el-collapse-item :title="currentLanguage">
              <div v-for="item of navLangList"
                :key="item.value"
                class="item k-body-md"
                @click="changeNavLanguage(item.value, 'affiliate'), showMenu = false"
              >{{ item.label }}</div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse>
            <el-collapse-item :title="`${affiliateInfo.contact_last_name || ''} ${affiliateInfo.contact_first_name || ''}`">
              <div class="item k-body-md" @click="handleCommand('1')" v-if="isKKpartners">{{ $t('common.nav.affiliate.switchToMerchantPortal') }}</div>
              <div class="item k-body-md" @click="handleCommand('2')">{{ $t('common.nav.affiliate.accountInfo') }}</div>
              <div class="item k-body-md" @click="handleCommand('3')">{{ $t('common.nav.logout') }}</div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { KkIcon, KkBadge, KkIconWithBadge, KkDropdown } from '@kkday/web-design-system'
import NavLanguageDropdownMixin from '@/mixins/nav-language-dropdown-mixin'
import UnreadNotification from '@/components/affiliate/unread-notification'
import { mixpanelTrack } from '@/libs/mixpanel'

export default {
  mixins: [ NavLanguageDropdownMixin ],
  components: {
    KkIcon, KkBadge, KkIconWithBadge, KkDropdown, UnreadNotification
  },
  computed: {
    currentPath() {
      return this.$route.path
    },
    affiliateInfo() {
      return this.$store.state.account?.userInfo?.affiliate || {}
    }
  },
  data() {
    return {
      showMenu: false,
      isKKpartners: Number(localStorage.getItem('isKKpartners')),
      unreadBadge: '',
      notifyVisible: false,
      isShowNewBadge: new Date().getTime() < new Date('2024/12/31').getTime()
    }
  },
  created() {
    if (localStorage.getItem('authToken')) {
      this.$store.dispatch('getAccountInfo')
    }
  },
  methods: {
    mixpanel(name) {
      mixpanelTrack(name)
    },
    goDefaultPage() {
      this.$router.push('/affiliate/dashboard')
    },
    handleToolsCommand(e) {
      if (e === '1') {
        mixpanelTrack(`NAV_Tool_Overview_Clicked`)
        this.$router.push('/affiliate/tools')
      } else if (e === '2') {
        mixpanelTrack(`NAV_Tool_CreatedLink_Clicked`)
        this.$router.push('/affiliate/exclusive-link')
      } else if (e === '3') {
        mixpanelTrack(`NAV_Tool_Campaign_Clicked`)
        this.$router.push('/affiliate/recent-activities')
      } else if (e === '4') {
        mixpanelTrack(`NAV_Tool_ProdMedia_Clicked`)
        this.$router.push('/affiliate/product-media')
      }
    },
    handleCommand(e) {
      if (e === '1') {
        if (this.isKKpartners == 1) {
          localStorage.setItem('extraChannel', 'MANAGE')
          this.$router.push('/manage/affiliate-cid')
        }
      }
      if (e === '2') {
        mixpanelTrack(`NAV_Accountinfo_Clicked`)
        this.$router.push('/affiliate/my-kkpartners')
      }
      if (e === '3') {
        console.log('authToken has been removed! here is affiliate')
        localStorage.removeItem('authToken')
        this.$store.state.account.userInfo = {}
        this.$store.state.memberReward.prodSponsorInfo = null
        this.$store.state.memberReward.fansDiscountInfo = null
        this.$router.push('/home')
      }
    },
    handleMenu() {
      this.showMenu = !this.showMenu
    },
    goPage(path) {
      if (path === '/affiliate/tools') {
        mixpanelTrack(`NAV_Tool_Overview_Clicked`)
      } else if (path === '/affiliate/exclusive-link') {
        mixpanelTrack(`NAV_Tool_CreatedLink_Clicked`)
      } else if (path === '/affiliate/recent-activities') {
        mixpanelTrack(`NAV_Tool_Campaign_Clicked`)
      } else if (path === '/affiliate/product-media') {
        mixpanelTrack(`NAV_Tool_ProdMedia_Clicked`)
      }
      this.$router.push(path)
      this.showMenu = false
    },
    onSetUnreadBadge(val) {
      this.unreadBadge = val || ''
    }
  }
}
</script>

<style lang="less" scoped>
.pc-header {
  width: 100%;
  height: 70px;
  position: fixed;
  left: 0%;
  top: 0%;
  z-index: 2000;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -1px 0px 0px #EEE inset;
  .content {
    width: 1170px;
    padding-left: var(--kk-spacing-5);
    padding-right: var(--kk-spacing-5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .item {
      cursor: pointer;
      padding: var(--kk-spacing-3) 0;
      margin: 0 var(--kk-spacing-7);
      text-decoration: none;
      &:visited {
        color: var(--kk-text-icon-color-text-darker);
      }
      &:hover {
        color: var(--kk-color-background-primary-dark);
      }
    }
  }
  .navigation {
    height: 40px;
    display: flex;
    align-items: center;
    color: var(--kk-text-icon-color-text-darker);
    font-size: 14px;
    a {
      color: var(--kk-text-icon-color-text-darker);
    }
    .logo {
      margin-right: var(--kk-spacing-10);
      cursor: pointer;
      img {
        width: 177px;
        height: 35px;
      }
    }
  }
  .system-info {
    display: flex;
    align-items: center;
    .info {
      font-size: 24px;
      position: relative;
      margin-right: var(--kk-spacing-5);
      display: flex;
      cursor: pointer;
      ::v-deep .kk-badge {
        background-color: #13A3B6;
      }
      .badge {
        background: #13A3B6;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 700;
        color: #fff;
        position: absolute;
        right: -6px;
        top: -4px;
        border: 2px solid #fff;
      }
    }
  }
  ::v-deep .el-dropdown-link {
    line-height: 40px;
    display: flex;
    white-space: nowrap;
    .el-icon-arrow-down {
      display: flex;
      align-items: center
    }
    &:hover {
      color: var(--kk-color-text-primary-medium);
    }
  }
}
.dropdown-item-product-media{
    display: flex;
    align-items: center;
    img{
        margin-left: 6px;
        width: 49px;
        height: 24px;
    }
}
.active {
  color: var(--kk-color-background-primary-dark) !important;
}
.mweb-header {
  display: none;
  width: 100%;
  padding: var(--kk-spacing-4) var(--kk-spacing-5);
  align-items: center;
  gap: var(--kk-spacing-5);
  position: fixed;
  left: 0%;
  top: 0%;
  z-index: 2000;
  background: #fff;
  .menu-btn {
    cursor: pointer;
  }
  .logo {
    margin-top: var(--kk-spacing-2);
    img {
      width: 151px;
      height: 30px;
    }
  }
}
@media (max-width: 996px) {
  .pc-header {
    display: none;
  }
  .mweb-header {
    display: flex;
    .el-drawer__wrapper {
      top: 63px;
    }
    ::v-deep .el-drawer__body {
      text-align: left;
    }
    .item {
      display: block;
      text-decoration: none;
    }
    a {
      color: var(--kk-text-icon-color-text-darker);
      &:visited {
        color: var(--kk-text-icon-color-text-darker);
      }
      &:hover {
        color: var(--kk-color-background-primary-dark);
      }
    }
    .menu-list {
      padding: var(--kk-spacing-7);
      .item {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
      }
      .active {
        color: var(--kk-color-background-primary-dark) !important;
      }
      ::v-deep .el-collapse-item__header {
        font-size: var(--kk-text-subtitle-md-font-size) !important;
        line-height: var(--kk-text-subtitle-md-line-height) !important;
        font-weight: var(--kk-text-body-md-font-weight) !important;
        font-family: "PingFang TC";
        height: 40px;
      }
      ::v-deep .is-active {
        font-weight: var(--kk-text-subtitle-md-font-weight) !important;
      }
      ::v-deep .el-collapse-item__header {
        border: none;
      }
      ::v-deep .el-collapse-item__content {
        padding-bottom: 0;
      }
      .notice-num {
        color: var(--kk-color-text-highlight-medium, #FFB400);
        padding-right: 8px;
      }
    }
  }
}
</style>
